// Slide themes of the former homepage carousel, still used by HeroBanner.
// One forest action per slide on a cream or sage ground. The warm accent lives only in the
// decorative background shapes.
export const THEMES = [
  {
    backgroundColor: '#f0f7f6',
    buttonType: 'primary',
    color: '#256955',
  },
  {
    backgroundColor: '#fbf7f0',
    buttonType: 'primary',
    color: '#CE9444',
  },
  {
    backgroundColor: '#fbf7f0',
    buttonType: 'primary',
    color: '#d06a59',
  },
  {
    backgroundColor: '#f0f7f6',
    buttonType: 'primary',
    color: '#256955',
  },
];
